<template>
  <v-container
    id="recovery"
    class="fill-height"
    tag="section"
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-slide-y-transition appear>
        <base-material-card
          id="auth"
          color="#0051ff"
          light
          max-width="100%"
          width="400"
          class="px-5 pb-2 py-3 auth-card"
        >
          <template v-slot:heading>
            <div class="text-center">
              <h1 class="display-2 font-weight-bold">
                Сброс пароля
              </h1>
            </div>
          </template>
          <v-snackbar
            v-model="snackbar"
            class="recovery-snakbar"
            absolute
            top
            color="success"
            :timeout="timeout = 985000"
          >
            <span>Пароль отправлен на почту, перейдите по ссылке, чтобы восстановить пароль.</span>
            <v-icon dark>
              mdi-checkbox-marked-circle
            </v-icon>
          </v-snackbar>
          <!-- ВОССТАНОВЛЕНИЕ ПАРОЛЯ -->
          <v-card-text class="text-center mt-5 recovery-card">
            <v-text-field
              v-model="recoveryEmail"
              v-validate="'required|email'"
              :error-messages="errors.collect('recoveryEmail')"
              label="E-mail"
              color="purple darken-2"
              data-vv-name="recoveryEmail"
              prepend-icon="mdi-email"
              clearable
              validate-on-blur
              required
            />

            <span class="d-flex">
              <v-btn
                color="#0051ff"
                medium
                rounded
                class="v-btn--text white--text"
                @click="submitRecovery()"
              >Отправить</v-btn>
              <v-btn
                color="#0051ff"
                medium
                rounded
                class="v-btn--text ml-auto white--text"
                @click="cancel()"
              >Отмена</v-btn>
            </span>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new',
    },
    name: 'PagesLogin',

    data: () => ({
      // иконка скрыть/показать пароль
      recoveryEmail: '',
      snackbar: false,
      lazy: false,
      // Валидация
      dictionary: {
        custom: {
          recoveryEmail: {
            required: () => 'Введите email',
            email: 'Невалидный email',
          },
        },
      },
    }),

    mounted () {
      this.$validator.localize('en', this.dictionary)
    },

    methods: {
      cancel () {
        this.$router.push({ name: 'Login' })
      },

      async submitRecovery () {
        const isValid = await this.$validator.validate()
        if (!isValid) {
          return
        }
        this.snackbar = true
        this.clearRecovery()
      },

      clearRecovery () {
        this.recoveryEmail = ''
        this.$validator.reset()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .pseudo {
    z-index: -2;
    position: relative;
  }

  .auth-card {
    @media (max-width: 992px) {
      max-width: 336px !important;
    }
  }

  #recovery {
    .v-snack.recovery-snakbar.v-snack--active.v-snack--absolute.v-snack--top {
      top: calc(50% - 80px);
      padding: 20px;
      line-height: 30px;
    }

    .recovery-card {
      height: 266px;
      display: flex;
      flex-direction: column;
    }
  }
</style>
